// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VerifiedOutlinedSvg from "@ant-design/icons-svg/es/asn/VerifiedOutlined";
import AntdIcon from '../components/AntdIcon';

var VerifiedOutlined = function VerifiedOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: VerifiedOutlinedSvg
  }));
};

VerifiedOutlined.displayName = 'VerifiedOutlined';
export default React.forwardRef(VerifiedOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/VerifiedOutlined.js
// module id = 2019
// module chunks = 0